<template>
  <BTableCommon
    type="publication-formdata-revisions"
    :list="revisions"
    :loading="isLoading"
    :skeleton="isLoadingAsyncData"
    style="max-height: 100%; overflow: auto;"
    @action:view="onViewRevision"
  />
</template>

<script>
import { createListMixin } from '@/helpers/mixins/createListMixin'
import {
  LKFormdataStoreModule as StoreModule,
  lkFormdataMapper as StoreMapper,
} from './store'
import { LkFormdataModel as Model } from './Model'
import { createLKPublicationsFormdataModal } from './utils'

import BTableCommon from '@/components/tables/BTableCommon.vue'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

export default {
  name: 'LKPublicationsFormdataRevisionsList',
  components: {
    BTableCommon,
  },
  mixins: [
    listMixin,
  ],
  inheritAttrs: false,
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    form_template_id: {
      type: [Number, String],
      required: true,
    },
  },
  data: (vm) => ({
    defaultParams: {
      id: vm.id,
    },
  }),
  computed: {
    ...StoreMapper.mapState([
      'revisions',
      'formTemplate',
    ]),

    getAll() {
      return this.storeModule.actions.revisions
    },
  },
  methods: {
    ...StoreMapper.mapActions([
      'revision',
      'getFormTemplate',
    ]),

    async onViewRevision(revision, callback) {
      const unwatch = callback?.()

      const options = {
        id: this.id,
        revision_id: revision.id,
      }

      const promises = [
        this.revision(options),
        this.formTemplate?.id === this.form_template_id
          ? this.formTemplate
          : this.getFormTemplate(this.form_template_id),
      ]

      try {
        const results = await Promise.all(promises)
        const propsData = { dataCollection: results[0], formTemplate: results[1], readonly: true }
        const modal = await createLKPublicationsFormdataModal(this, propsData)
        modal.open()
      } catch (error) {
        this.$notice.errors(error)
        return
      } finally {
        unwatch?.()
      }
    },
  },
}
</script>
